// extracted by mini-css-extract-plugin
export default {"header":"styles_header__bytNS","tie":"styles_tie__lLjOr","input":"styles_input__FCBza","check":"styles_check__-RMUT","label":"styles_label__cyerb","value":"styles_value__qFvVx"};